export function OutlineCoinIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.887 20C16.3052 20 19.887 16.4183 19.887 12C19.887 7.58172 16.3052 4 11.887 4C7.46868 4 3.88696 7.58172 3.88696 12C3.88696 16.4183 7.46868 20 11.887 20Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M11.8872 7.55664V9.33229" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M11.8872 14.6641V16.4445" stroke={stroke} strokeWidth={strokeWidth} />
      <path
        d="M14.258 13.3344C13.7973 14.1359 12.9335 14.6638 11.9449 14.6638C10.4716 14.6638 9.27661 13.4736 9.27661 11.9955C9.27661 10.5174 10.4716 9.33203 11.9449 9.33203C12.9287 9.33203 13.7925 9.86472 14.258 10.6614"
        stroke={stroke}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}
